// Mouse + touch input. Slicing only happens while pressed; the trail follows the pointer.
import { G } from '../game/state';
import { bladeSegment } from '../game/slice';
import { resumeAudio } from '../fx/audio';
import type { Point } from '../game/types';

function pointerPos(e: MouseEvent | TouchEvent): Point {
  const p = (e as TouchEvent).touches ? (e as TouchEvent).touches[0] : (e as MouseEvent);
  return { x: p.clientX, y: p.clientY };
}

function onDown(e: MouseEvent | TouchEvent): void {
  resumeAudio();
  G.dragging = true;
  G.lastP = pointerPos(e);
  G.trail.push({ ...G.lastP, t: performance.now() });
}

function onMove(e: MouseEvent | TouchEvent): void {
  if (!G.dragging) return;
  const p = pointerPos(e);
  G.trail.push({ ...p, t: performance.now() });
  if (G.lastP) bladeSegment(G.lastP.x, G.lastP.y, p.x, p.y);
  G.lastP = p;
  e.preventDefault();
}

function onUp(): void {
  G.dragging = false;
  G.lastP = null;
}

export function attachPointer(): void {
  const canvas = G.canvas;
  canvas.addEventListener('mousedown', onDown);
  canvas.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  canvas.addEventListener('touchstart', onDown, { passive: false });
  canvas.addEventListener('touchmove', onMove, { passive: false });
  canvas.addEventListener('touchend', onUp);
}
